import SEO from "@/components/SEO";

// Shared layout for text pages: policies, About, FAQ, Contact.
export default function InfoPage({ title, seoTitle, description, updated, testid = "info-page", children }) {
  return (
    <div data-testid={testid} className="bg-[#0A0A0A] min-h-screen">
      <SEO title={seoTitle || `${title} | AERWEAR`} description={description} />
      <header className="px-6 sm:px-12 pt-16 pb-10 sm:pt-24 sm:pb-14 text-center border-b border-[#8A8A8A]/20">
        <h1 className="text-2xl sm:text-4xl font-medium uppercase tracking-[0.18em] text-[#F2F0EB] leading-tight">{title}</h1>
        {updated && <p data-testid="last-updated" className="mt-5 text-xs text-[#8A8A8A]">Last updated: {updated}</p>}
      </header>
      <div className="max-w-2xl mx-auto px-6 py-12 sm:py-16">
        <div className="info-content text-[15px] text-[#C9C7C2] leading-relaxed space-y-6">{children}</div>
      </div>
    </div>
  );
}

// A paragraph that opens with a bold run-in lead, e.g. "Tracking." followed by the text.
export function Lead({ lead, children }) {
  return (
    <p>
      <strong className="font-semibold text-[#F2F0EB]">{lead}</strong>
      {children ? <> {children}</> : null}
    </p>
  );
}

export const linkClass = "underline underline-offset-2 text-[#F2F0EB] hover:text-[#8A8A8A] transition-colors";
